import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

// import { CarsRoutingModule } from './cars-routing.module';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MatRippleModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {CarDialogOverviewComponent} from './car-dialog-overview/car-dialog-overview.component';
import {CarouselModule} from 'primeng/carousel';
import {CarModalGaComponent} from './car-modal/car-modal-ga.component';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import {NbEvaIconsModule} from '@nebular/eva-icons';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FreightSharedModule} from '../freight-shared/freight-shared.module';
import {MatIconModule} from '@angular/material/icon';
import {ImageDialogComponent} from './image-dialog/image-dialog.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ToastModule} from 'primeng/toast';
import {MatRadioModule} from '@angular/material/radio';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {FlexModule} from '@angular/flex-layout';
import {MatFormFieldModule} from '@angular/material/form-field';
import {CarModalSellerGaComponent} from './car-modal-seller-ga/car-modal-seller-ga.component';
import {ConfirmationSellerDialogComponent} from './car-modal-seller-ga/confirmation-cancel-seller.component';
import {ThankYouDialogSellerComponent} from './car-modal-seller-ga/thank-you-dialog-seller.component';
import {CarsGridSellerGaComponent} from './cars-grid-seller-ga/cars-grid-seller-ga.component';
import {UserInfoGaModalComponent} from './user-info-ga/user-info-ga-modal.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TranslateModule} from '@ngx-translate/core';


@NgModule({
    declarations: [
        CarsGridSellerGaComponent,
        CarDialogOverviewComponent,
        CarModalGaComponent,
        CarModalSellerGaComponent,
        ImageDialogComponent,
        ConfirmationSellerDialogComponent,
        ThankYouDialogSellerComponent,
        UserInfoGaModalComponent
    ],
    imports: [
        CommonModule,
        // CarsRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatButtonModule,
        FontAwesomeModule,
        MatRippleModule,
        MatDialogModule,
        CarouselModule,
        NbCardModule,
        NbIconModule,
        NbButtonModule,
        NbDialogModule.forRoot(),
        NbIconModule,
        NbEvaIconsModule,
        NbInputModule,
        NgSelectModule,
        NbFormFieldModule,
        ReactiveFormsModule,
        FreightSharedModule,
        NbToggleModule,
        MatIconModule,
        AngularSvgIconModule,
        NbTooltipModule,
        MatBottomSheetModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        ToastModule,
        MatRadioModule,
        NgxSliderModule,
        NgxSliderModule,
        FormsModule,
        MatTableModule,
        MatInputModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        FlexModule,
        MatTabsModule,
        TranslateModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CarsGaModule { }
